import {
	getRetailShopId,
	getRowChannelValue,
	getShopDisplayName,
	parseListResponse,
} from './retailShopChannel'

export const ALL_CHANNEL_OPTION = {
	id: 0,
	code: '所有渠道',
	name: '所有渠道',
}

export const ROUND_TYPE_LABELS = {
	round: '四舍五入',
	floor: '向下取整',
	ceil: '向上取整',
}

const allocationListInflight = {}

export function mapAllocationListRow(item) {
	const channel = item.channel && typeof item.channel === 'object' ? item.channel : {}
	const channelId = item.channel_id != null ? Number(item.channel_id) : Number(channel.id || 0)
	const roundType = item.round_type || ''

	return {
		id: item.id,
		channel_id: channelId,
		shop_name: getShopDisplayName(item),
		channel: channel,
		channel_code: channelId === 0
			? ALL_CHANNEL_OPTION.code
			: getRowChannelValue({ channel: channel }, ['code', 'channel_code']),
		channel_name: channelId === 0
			? ALL_CHANNEL_OPTION.name
			: getRowChannelValue({ channel: channel }, ['name', 'channel_name']),
		min_qty: item.min_quantity != null ? item.min_quantity : '',
		max_qty: item.max_quantity != null ? item.max_quantity : '',
		push_ratio: item.push_ratio != null ? item.push_ratio : '',
		state: normalizeAllocationState(item),
		decimal_type: roundType,
		decimal_label: ROUND_TYPE_LABELS[roundType] || roundType,
		sort_order: item.sort_order != null ? item.sort_order : '',
	}
}

export function normalizeAllocationState(item) {
	if (item.state != null && item.state !== '') {
		return Number(item.state)
	}
	if (item.is_enabled === true || item.is_enabled === 1 || item.is_enabled === '1') {
		return 1
	}
	if (item.is_enabled === false || item.is_enabled === 0 || item.is_enabled === '0') {
		return 2
	}
	return 1
}

export function buildAllocationSavePayload(retailShopId, form) {
	const payload = {
		retail_shop_id: Number(retailShopId),
		channel_id: Number(form.channelId),
		min_quantity: Number(form.minQty),
		max_quantity: Number(form.maxQty),
		push_ratio: Number(form.pushRatio),
		round_type: form.decimalType,
		is_enabled: 1,
	}

	if (form.id != null && form.id !== '') {
		payload.id = form.id
	}

	if (form.sortOrder != null && form.sortOrder !== '') {
		payload.sort_order = Number(form.sortOrder)
	}

	return payload
}

export function allocationStateToIsEnabled(state) {
	return state === 1 ? 1 : 0
}

export function buildAllocationTogglePayload(row, state) {
	return {
		id: row.id,
		is_enabled: allocationStateToIsEnabled(state),
	}
}

export function toggleShopAllocationState(axios, row, state) {
	return axios.post('api/retail_shop/allocation_toggle', buildAllocationTogglePayload(row, state)).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '状态更新失败')
		}
		return res.data
	})
}

export function saveShopAllocationState(axios, row, state) {
	return toggleShopAllocationState(axios, row, state)
}

export function saveShopAllocation(axios, payload) {
	return axios.post('api/retail_shop/allocation_save', payload).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '保存失败')
		}
		return res.data
	})
}

export function deleteShopAllocation(axios, id) {
	return axios.post('api/retail_shop/allocation_delete', { id: id }).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '删除失败')
		}
		return res.data
	})
}

export function fetchShopAllocationList(axios, id, options) {
	const opts = options || {}
	const cacheKey = String(id) + ':' + String(opts.page || 1) + ':' + String(opts.limit != null ? opts.limit : 0)

	if (!opts.force && allocationListInflight[cacheKey]) {
		return allocationListInflight[cacheKey]
	}

	allocationListInflight[cacheKey] = axios.post('api/retail_shop/allocation_list', {
		retail_shop_id: id,
		page: opts.page != null ? opts.page : 1,
		limit: opts.limit != null ? opts.limit : 0,
	}).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '获取库存显示规则列表失败')
		}
		return parseListResponse(res.data.data).map(mapAllocationListRow)
	}).finally(function() {
		delete allocationListInflight[cacheKey]
	})

	return allocationListInflight[cacheKey]
}

export { getRetailShopId }


// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/retailShopAllocation.js